import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const hotArticles = articles.filter((a) => a.hot).slice(0, 6);

export default function HotRecommendations() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              读者最爱内容，热度排行不容错过
            </p>
          </div>
          <Link
            to="/category/yule"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap"
          >
            更多热门 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {hotArticles.map((article, index) => (
            <article
              key={article.id}
              className="group flex flex-col bg-background-100 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.01]"
            >
              <Link to={`/article/${article.id}`} className="block">
                <div className="relative aspect-[16/9] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.imageAlt}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={article.imageAlt}
                  />
                  <div className="absolute top-3 left-3 flex items-center gap-2">
                    <span className="px-2 py-0.5 text-xs font-bold rounded bg-accent-500 text-white">
                      热门
                    </span>
                    <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold text-white ${
                      index === 0 ? 'bg-accent-500' : index === 1 ? 'bg-secondary-500' : index === 2 ? 'bg-primary-500' : 'bg-background-600'
                    }`}>
                      {index + 1}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5 flex-1 flex flex-col">
                  <span className="text-xs text-accent-600 font-medium mb-2">
                    {article.category}
                  </span>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors duration-200 mb-2 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>
                  <div className="mt-auto flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {article.views.toLocaleString()} 阅读
                    </span>
                    <span>·</span>
                    <span>{article.readTime}</span>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>

        <div className="mt-6 sm:hidden text-center">
          <Link
            to="/category/yule"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors"
          >
            更多热门 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}